<ng-container>

  @if (context == 'survey-team') {
  <form class="team-member-flex-container team-member-inline-form" #surveyTeamForm="ngForm"
    (keydown.enter)="$event.preventDefault()" novalidate (ngSubmit)="addSurveyTeamMember(surveyTeamForm)">

    <div class="tm-row">
      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.name' | translate }}</mat-label>
          <input matInput name="survey_team_member_name" [(ngModel)]="teamMember.name"
            placeholder="{{ 'generic.name' | translate }}" autocomplete="off" autocorrect="off" autocapitalize="off"
            spellcheck="false" required />
        </mat-form-field>
      </div>

      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.surname' | translate }}</mat-label>
          <input matInput name="survey_team_member_last_name" [(ngModel)]="teamMember.last_name"
            placeholder="{{ 'generic.surname' | translate }}" autocomplete="off" autocorrect="off" autocapitalize="off"
            spellcheck="false" required />
        </mat-form-field>
      </div>
    </div>

    <div class="tm-row">
      <div class="field-group flex-grow-1 half-width" (click)="onClickSearchUser(teamMember)">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.email' | translate }}</mat-label>
          <input type="email" matInput name="survey_team_member_email" [value]="teamMember.email" autocomplete="false"
            (input)="onInputSearchUserChange($event.target.value, teamMember)"
            placeholder="{{ 'generic.email' | translate }}" [matAutocomplete]="auto" autocomplete="off"
            autocorrect="off" autocapitalize="off" spellcheck="false" required>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
            (optionSelected)="setUserInfoByEmail($event, teamMember)">
            @for (option of suggestedTeamMemberUsers; track option) {
            <mat-option [value]="option">
              {{option.email}}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="field-group flex-grow-1 quarter-width">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.roles.role' | translate }}</mat-label>
          <mat-select name="survey_team_member_role" [(ngModel)]="teamMember.role"
            (ngModelChange)="onRoleChange($event, teamMember)" placeholder="{{ 'generic.roles.role' | translate }}">
            <mat-option value=""><em>Nessuno</em></mat-option>
            <mat-option value="editor">Editor</mat-option>
            <mat-option value="viewer">Viewer</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="field-group slide-group">
        <mat-slide-toggle color="primary" name="survey_team_member_is_respondent" [(ngModel)]="teamMember.is_respondent"
          [disabled]="!teamMember.role">
          <span class="respondent-label">{{ 'generic.is-respondent' | translate }}</span>
        </mat-slide-toggle>
      </div>

      @if (addButton) {
      <div class="field-group action-group">
        <button type="submit" matButton="filled" color="primary" class="add-btn">
          <mat-icon>add</mat-icon> {{'generic.buttons.add' | translate}}
        </button>
      </div>
      }
    </div>
  </form>
  } @else {
  <div class="team-member-flex-container team-member-card">
    <div class="tm-row">
      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.name' | translate }}</mat-label>
          <input matInput name="team_member_name" [(ngModel)]="team_member.name"
            placeholder="{{ 'generic.name' | translate }}" required />
        </mat-form-field>
      </div>

      <div class="field-group flex-grow-1">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.surname' | translate }}</mat-label>
          <input matInput name="team_member_last_name" [(ngModel)]="team_member.last_name"
            placeholder="{{ 'generic.surname' | translate }}" required />
        </mat-form-field>
      </div>
    </div>

    <div class="tm-row">
      <div class="field-group flex-grow-1 half-width" (click)="onClickSearchUser(team_member)">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.email' | translate }}</mat-label>
          <input type="email" matInput name="team_member_email" [value]="team_member.email" autocomplete="false"
            (input)="onInputSearchUserChange($event.target.value, team_member)"
            placeholder="{{ 'generic.email' | translate }}" [matAutocomplete]="auto_else" required>
          <mat-autocomplete #auto_else="matAutocomplete" [displayWith]="displayFn"
            (optionSelected)="setUserInfoByEmail($event, team_member)">
            @for (option of suggestedTeamMemberUsers; track option) {
            <mat-option [value]="option">
              {{option.email}}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="field-group flex-grow-1 quarter-width">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-0">
          <mat-label>{{ 'generic.roles.role' | translate }}</mat-label>
          <mat-select name="team_member_role" [(ngModel)]="team_member.role"
            (ngModelChange)="onRoleChange($event, team_member)" placeholder="{{ 'generic.roles.role' | translate }}">
            <mat-option value=""><em>Nessuno</em></mat-option>
            <mat-option value="editor">Editor</mat-option>
            <mat-option value="viewer">Viewer</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="field-group slide-group">
        <mat-slide-toggle color="primary" name="team_member_is_respondent" [(ngModel)]="team_member.is_respondent"
          [disabled]="!team_member.role">
          <span class="respondent-label">{{ 'generic.is-respondent' | translate }}</span>
        </mat-slide-toggle>
      </div>

      <div class="field-group action-group">
        @if (removable) {
        <button mat-icon-button color="warn" (click)="removeTeamMember()" class="delete-btn"
          matTooltip="{{ 'generic.delete' | translate }}">
          <mat-icon>delete_outline</mat-icon>
        </button>
        }
      </div>
    </div>
  </div>
  @if (false) {
  <mat-form-field class="select-primary col-6 col-md-3" appearance="fill">
    <mat-label>{{
      "generic.roles.professional-role" | translate
      }}</mat-label>
    <mat-select name="team_member_professional_role" [(ngModel)]="
                            team_member.organization_professional_role_id
                          ">
      <mat-option value="" selected></mat-option>
      @for (professionalRole of professionalRoles; track professionalRole) {
      <mat-option [value]="professionalRole.id">{{ professionalRole.role }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
  @if (process_role_field) {
  <mat-form-field class="select-primary col-4" appearance="fill">
    <mat-label>{{
      "generic.roles.process-role" | translate
      }}</mat-label>
    <mat-select name="team_member_process_role" [(ngModel)]="team_member.process_role" required>
      <mat-option value="" selected></mat-option>
      @for (processRole of process_roles; track processRole) {
      <mat-option [value]="processRole.key">{{
        processRolesService.getProcessRolesValueByKey(
        processRole.key
        )
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
  @if (false) {
  <mat-form-field class="select-primary col-3 col-md-2" appearance="fill">
    <mat-label>{{
      "generic.weight" | translate
      }}</mat-label>
    <mat-select name="team_member_weight{{ i }}" [(ngModel)]="team_member.weight">
      <mat-option value=""></mat-option>
      <mat-option [value]="100">100</mat-option>
    </mat-select>
  </mat-form-field>
  }
  }
  <!-- <div class="mt-4">
      <div class="toggle-container col-4 d-inline-block" appearance="fill">
        <mat-label>{{'components.decision-table.show-decision-table.ask-authorization-full-evaluation' | translate}}</mat-label>
        <div>
          <span class="mr-2">{{'generic.answers.no' | translate}}</span>
          <mat-slide-toggle class="toggle" name="team_member_complete_process_enabled{{i}}" [(ngModel)]="team_member.complete_process_enabled">{{'generic.answers.yes' | translate}}</mat-slide-toggle>
        </div>
      </div>
      <div class="toggle-container col-4 d-inline-block" appearance="fill">
        <mat-label>{{'components.decision-table.show-decision-table.ask-authorization-review' | translate}}</mat-label>
        <div>
          <span class="mr-2">{{'generic.answers.no' | translate}}</span>
          <mat-slide-toggle class="toggle" name="team_member_review_enabled{{i}}" [(ngModel)]="team_member.review_enabled">{{'generic.answers.yes' | translate}}</mat-slide-toggle>
        </div>
      </div>
      <div class="toggle-container col-4 d-inline-block" appearance="fill">
        <mat-label>{{'components.decision-table.show-decision-table.ask-authorization-new-proposal' | translate}}</mat-label>
        <div>
          <span class="mr-2">{{'generic.answers.no' | translate}}</span>
          <mat-slide-toggle class="toggle" name="team_member_provide_new_proposal_enabled{{i}}" [(ngModel)]="team_member.provide_new_proposal_enabled">{{'generic.answers.yes' | translate}}</mat-slide-toggle>
        </div>
      </div>
    </div> -->
  @if (process_role_field && false) {
  <!-- the rest of the old form fields disabled -->
  }
</ng-container>

@if (team_member?.imported_by_organization_chart_id) {
<span class="text-center mt-4 col-12 main-color">
  {{ 'generic.imported-by' | translate }} "{{
  getOrganizationChart(team_member?.imported_by_organization_chart_id)?.title }}"
</span>
}
